import e from "react";
import { getIconColor as d } from "./iconfont.es5474.js";
import m from "./iconfont.es5475.js";
const a = {
  display: "block"
}, p = ({ size: t = 16, color: r, useVw: o, useRem: c, disableSSR: i, style: n, ...l }) => {
  const s = n ? { ...a, ...n } : a;
  return /* @__PURE__ */ e.createElement(m, { disableSSR: i }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "icon-a-v31-16px-line-success", "data-icon-group": "GateUI", "data-icon-version": "0.8.1", viewBox: "0 0 1024 1024", width: o ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (c ? "rem" : "px"), height: o ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (c ? "rem" : "px"), style: s, ...l }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M928.32 265.472a44.8 44.8 0 0 1-1.28 63.36L430.08 806.208a44.8 44.8 0 0 1-63.552-1.536L95.488 518.272a44.8 44.8 0 0 1 65.024-61.632L400.64 710.4l464.384-446.144a44.8 44.8 0 0 1 63.36 1.28z",
      fill: d(r, 0, "currentColor")
    }
  )));
}, f = p;
export {
  f as default
};
